import React, {useCallback, useEffect, useState} from 'react';
import {connect} from 'react-redux';
import NewMemberRequests from 'components/guilds/NewMemberRequests.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import Toast from './Toast.js';
import GuildRequests from './GuildRequests.js';
import PulseLoader from 'react-spinners/PulseLoader'
import CreateNewGuild from './CreateNewGuild.js';
import ethereum from 'decentralized/ethereum.js';
import GuildDetails from './GuildDetails.js';

const ExploreGuilds = ({numPending}) => {
    const [selectedGuild, setSelectedGuild] = useState(undefined);
    const [syncingGuilds, setSyncingGuilds] = useState(false);
    const [creatingNewGuild, setCreatingNewGuild] = useState(false);
    const [guilds, setGuilds] = useState([]);

    const newGuildCallback = useCallback(() => {
        getGuilds();
        setSyncingGuilds(false);
    }, [setGuilds, setSyncingGuilds]);

    ethereum.guilds.newGuildCallback = newGuildCallback;

    const getGuilds = useCallback(() => {
        ethereum.guilds.getGuildsForUser()
            .then(async (guilds) => {
                let _guilds = [];
                for (let i in guilds) {
                    let guild = guilds[i];
                    if (guild.name.split(",").length >= 2) {
                        continue;
                    }
                    let members = await ethereum.guilds.getUsersInGuild(guild.guildId);
                    guild.members = members;
                    _guilds.push(guild);
                }
                setGuilds(_guilds)
;
            });
    }, [setGuilds, numPending]);

    useEffect(() => {
        getGuilds();
   }, [setGuilds]);

    const onLeftGuild = useCallback((guild) => {
        let i = guilds.indexOf(guild);
        let _guilds = [... guilds];
        _guilds.splice(i, 1);
        setGuilds(_guilds);
    }, [guilds, setGuilds]);

    if (creatingNewGuild) {
        return (
            <div className="explore-guilds">
              <CreateNewGuild
                done={() => {
                    setCreatingNewGuild(false);
                    setSyncingGuilds(true);
                }}
                cancel={() => setCreatingNewGuild(false)}/>
            </div>
        );
    }

    return (
        <div className="explore-guilds">
          <div className="top-bar">
            <div
              onClick={() => setCreatingNewGuild(true)}
              className="create-guild-button">
              Create New Group
            </div>
            <Toast/>
            <GuildRequests/>
          </div>
          <ConditionedComponent condition={syncingGuilds}>
            Syncing guild changes
            <PulseLoader
              sizeUnit={"px"}
              size={10}
              color={'#42f4f1'}
              loading={true}
            />
          </ConditionedComponent>

          <div className="guilds-content">
            <div className="guilds-chooser">
              {guilds.map(
                  guild =>
                      <GuildOption
                        selected={guild === selectedGuild}
                        onClick={() => setSelectedGuild(guild)}
                        guild={guild}/>)}
            </div>
            <GuildDetails onLeftGuild={onLeftGuild}
                          onHide={() => setSelectedGuild(undefined)} guild={selectedGuild}/>
          </div>
        </div>);
};

const GuildOption = (props) => {
    let className = "guild-option";
    if (props.selected) {
        className += " selected";
    }
    return (
        <div
          onClick={props.onClick}
          className={className}>
          {props.guild.name}
        </div>
    );
};

const mapStateToProps = (state, props) => {
    return {
        numPending: state.transactions.pendingTransactions.length
    };
};


export default connect(mapStateToProps, null)(ExploreGuilds);
